import React, { useState, useCallback, useRef, useEffect } from "react";
import FlightDelayWrapper from "./flightDelay.style";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import * as travelService from "../../../../services/travel-service";
import {
  setLoading,
  updateFlightCover,
  updateFlightProposal,
  updateTravelDetails,
} from "../../../../redux/actions/travel";
import { Toast } from "primereact/toast";
import moment from "moment";
import * as utils from "../../helpers/utils";
import { useSelector } from "react-redux";
import FlightDelayList from "../FlightDeliayList";
import { FormikProvider, useFormik } from "formik";
import { Calendar } from "primereact/calendar";
import { classNames } from "primereact/utils";
import {
  BUSINESS_LINE_COLORS,
  BUSINESS_LINE_PATHS,
} from "../../../../helpers/utils";

const FlightDelay = (props) => {
  const { t } = props;
  const { show = false } = props;
  const toast = useRef(null);
  const dispatch = useDispatch();
  const applicants = useSelector((state) => state.travel.applicants);
  const travelDetails = useSelector((state) => state.travel.travelDetails);
  const flightProposal = useSelector((state) => state.travel.flightProposal);
  const [showFlightList, setShowFlightList] = useState(false);
  const [updatedFlightProposal, setUpdatedFlightProposal] =
    useState(flightProposal);
  const error = "";

  const formik = useFormik({
    initialValues: {
      flightNumber: "",
      depDate: "",
    },
    validate: (data) => {
      let errors = {};
      if (!data.flightNumber) {
        errors.flightNumber = t("required");
      }
      if (!data.depDate) {
        errors.depDate = t("required");
      }

      return errors;
    },
    onSubmit: (data) => {
      getFlightDetails(data);
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <div className="p-error text-initial position-relative">
          {formik.errors[name]}
        </div>
      )
    );
  };

  useEffect(() => {
    if (show && (!flightProposal || !flightProposal.quoteList)) {
      formik.resetForm();
    }
  }, [show]);

  const getFlightProposal = useCallback(
    (flightDetails) => {
      dispatch(setLoading(true));
      travelService
        .getFlightProposal(
          utils.buildFlightProposalRequest(
            { ...travelDetails, ...flightDetails, applicants: applicants },
            props.i18n.language
          )
        )
        .then((response) => {
          dispatch(setLoading(false));
          if (response.data.resultCode === "S") {
            // dispatch(updateFlightProposal(response.data));
            setUpdatedFlightProposal(response.data);
            setShowFlightList(true);
          } else {
            toast.current.show({
              severity: "error",
              details: response.data.resultMessage,
            });
          }
        });
    },
    [travelDetails, applicants, props.i18n.language]
  );

  const getFlightDetails = useCallback(
    (data) => {
      const obj = {
        applicationRef: "SPFD",
        departureDate: moment(data.depDate).format("DD/MM/YYYY"),
        flightNumber: data.flightNumber,
        lang: props.i18n.language,
      };
      dispatch(setLoading(true));
      travelService.getFlightDetails(obj).then((response) => {
        dispatch(setLoading(false));
        if (response.data.resultCode === "S") {
          getFlightProposal(response.data.flightList[0]);
        } else {
          toast.current.show({
            severity: "error",
            detail: response.data.resultMessage,
            life: 10000,
          });
        }
      });
    },
    [props.i18n.language, formik.values.flightNumber, getFlightProposal]
  );

  const onSelectCover = (coverCode) => {
    dispatch(updateFlightCover(coverCode));
    if (!props.flightNumber) {
      travelDetails["flightNumber"] = formik.values.flightNumber;
      dispatch(updateTravelDetails(travelDetails));
      dispatch(updateFlightProposal(updatedFlightProposal));

      props.onCancel();
    } else {
      props.onCancel();
    }
  };
  const onCancel = () => {
    travelDetails["flightNumber"] = "";
    setUpdatedFlightProposal({});
    setShowFlightList(false);
    dispatch(updateTravelDetails(travelDetails));
    dispatch(updateFlightProposal({}));
    props.onCancel();
  };

  const { businessLine } = useSelector((state) => state.travel);

  // REBRANDING COLORS
  let businessColor = BUSINESS_LINE_COLORS.DEFAULT;
  if (businessLine === BUSINESS_LINE_PATHS.STC)
    businessColor = BUSINESS_LINE_COLORS.STC;

  return (
    <Dialog
      visible={show}
      showHeader={false}
      closable={true}
      modal={true}
      contentClassName="rounded-3"
      maskClassName="flightdelay"
      style={{ color: businessColor }}
    >
      <Toast ref={toast} />
      {showFlightList ? (
        <FlightDelayList
          show={showFlightList}
          onCancel={onCancel}
          onSelect={onSelectCover}
          proposal={updatedFlightProposal}
        />
      ) : (
        <FlightDelayWrapper>
          <div
            className={
              "main pt-4 " + (props.i18n.language === "ar" ? "ar" : "")
            }
          >
            <div className="row">
              {error && (
                <small id="username2-help" className="p-error block">
                  {error?.message}
                </small>
              )}

              <FormikProvider value={formik}>
                <form onSubmit={formik.handleSubmit}>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <div className="field text-initial">
                        <InputText
                          id="flightNumber"
                          name="flightNumber"
                          value={formik.values.flightNumber}
                          onChange={formik.handleChange}
                          // className="lato"
                          className={`w-100  ${classNames({
                            lato: formik.values.flightNumber,
                          })}`}
                          placeholder={props.t("flight-no")}
                          required
                        />
                        {getFormErrorMessage("flightNumber")}
                      </div>
                    </div>
                    <div className="col-md-12 mb-3">
                      <div className="field text-initial">
                        <Calendar
                          className={`w-100 custom-calendar-input ${classNames({
                            "p-invalid": isFormFieldValid("deptDate"),
                            lato: formik.values.deptDate,
                          })}`}
                          style={{ background: businessColor }}
                          required={true}
                          placeholder={t("DepartureDate")}
                          dateFormat="yy-mm-dd"
                          inputClassName={`${classNames({
                            "p-invalid": isFormFieldValid("deptDate"),
                            lato: formik.values.deptDate,
                          })}`}
                          inputId="depDate"
                          minDate={new Date()}
                          value={
                            formik.values.depDate
                              ? new Date(formik.values.depDate)
                              : ""
                          }
                          readOnlyInput
                          showIcon
                          onChange={(data) => {
                            formik.setFieldTouched("depDate", true);
                            formik.setFieldValue(
                              "depDate",
                              moment(data.value).format("YYYY-MM-DD")
                            );
                          }}
                        />
                        {getFormErrorMessage("depDate")}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <Button
                        label={props.t("calculate")}
                        type="submit"
                        className="p-button-warning w-100"
                      />
                    </div>
                    <div className="col-6">
                      <Button
                        type="button"
                        label={props.t("cancel")}
                        className="p-button-outlined p-button-info w-100"
                        onClick={onCancel}
                      />
                    </div>
                  </div>
                </form>
              </FormikProvider>
            </div>
          </div>
        </FlightDelayWrapper>
      )}
    </Dialog>
  );
};

export default withTranslation()(FlightDelay);
